// extracted by mini-css-extract-plugin
module.exports = {"root":"InboxFeed_root__3mP64","messageError":"InboxFeed_messageError__2K9ZQ"};